import { render, staticRenderFns } from "./bin-location.vue?vue&type=template&id=df213ad4"
import script from "./bin-location.vue?vue&type=script&lang=js"
export * from "./bin-location.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports